<div class="document-container p-md-3">
  <div>
    <h3 class="document-title mb-0">
      <img src="/icons/vsh/pdf.svg" alt="" />
      {{ document().altText }}
    </h3>
  </div>

  <a
    class="document-container-cta-btn text-center"
    [href]="baseurl() + document().url"
    target="_blank"
    (click)="sendViewDocumentEvent(document().altText)"
    [type]="document().mimeType"
    >
    View
    <img src="/icons/vsh/external-link2.svg" alt="" />
  </a>

  <a
    class="document-container-cta-btn text-center"
    [href]="baseurl() + document().downloadUrl"
    download
    (click)="sendDownloadDocumentEvent(document().altText)"
    [type]="document().mimeType"
  >
    Download
    <img src="/icons/vsh/download-icon.svg" alt="" />
  </a>
</div>
